import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Row, Spinner, Table } from "reactstrap";
import {
    acceptMomentoReuest,
    getMomentoRequests,
} from "../../store/actions/MomentosActions";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

const MomentoRequests = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { uid, user } = useSelector((state) => state.authUser);
    const { momentoRequests, loading } = useSelector((state) => state.momentos);
    const [Requests, setRequests] = useState([]);
    useEffect(() => {
        dispatch(getMomentoRequests(uid));
    }, []);
    useEffect(() => {
        if (momentoRequests.length > 0) {
            setRequests(momentoRequests);
        }
    }, [momentoRequests]);

    return (
        <>
            <Container fluid>
                <Row className="justify-content-center mx-4 py-3">
                    <h3>Memento Requests</h3>
                </Row>
                <Container>
                    {loading ? (
                        <Row className="justify-content-center">
                            <Spinner size="sm" />
                        </Row>
                    ) : (
                        <Table hover bordered>
                            <thead>
                                <tr>
                                    <th className="text-capitalize">
                                        request ID
                                    </th>
                                    <th className="text-capitalize">
                                        Fan Name
                                    </th>
                                    <th className="text-capitalize">
                                        description
                                    </th>
                                    <th className="text-capitalize">status</th>
                                    <th className="text-capitalize">action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Requests.length > 0 ? (
                                    Requests?.map((item) => {
                                        return (
                                            <tr key={item.id} color="blue">
                                                <td>{item.id}</td>
                                                <td className="text-capitalize">
                                                    {item.fan_name}
                                                </td>
                                                <td>{item?.description}</td>
                                                <td className="text-capitalize">
                                                    {item?.status}
                                                </td>
                                                <td className="text-center">
                                                    <Button
                                                        size="sm"
                                                        color="primary"
                                                        disabled={
                                                            item.status !==
                                                            "pending"
                                                        }
                                                        onClick={() => {
                                                            // if (
                                                            //     user?.momentoCount <
                                                            //     3
                                                            // ) {
                                                            dispatch(
                                                                acceptMomentoReuest(
                                                                    item.id,
                                                                    "accepted",
                                                                    () => {
                                                                        history.push(
                                                                            `/main/create-momentos/${item.id}`
                                                                        );
                                                                    }
                                                                )
                                                            );
                                                            // } else {
                                                            //     toast.error(
                                                            //         "You have Reached your limit of mementos, either delete one or wait until one of your unique memenot is sold"
                                                            //     );
                                                            // }
                                                        }}
                                                    >
                                                        {item.status ==
                                                        "accepted"
                                                            ? "Accepted"
                                                            : "Accept"}
                                                    </Button>
                                                    {(item?.status ==
                                                        "rejected" ||
                                                        item?.status ==
                                                            "pending") && (
                                                        <Button
                                                            size="sm"
                                                            color="danger"
                                                            className="mx-2"
                                                            disabled={
                                                                item.status !==
                                                                "pending"
                                                            }
                                                            onClick={() =>
                                                                dispatch(
                                                                    acceptMomentoReuest(
                                                                        item.id,
                                                                        "rejected"
                                                                    )
                                                                )
                                                            }
                                                        >
                                                            {item.status ==
                                                            "rejected"
                                                                ? "Declined"
                                                                : "Decline"}
                                                        </Button>
                                                    )}
                                                    {item?.status ===
                                                        "accepted" && (
                                                        <Button
                                                            size="sm"
                                                            color="danger"
                                                            className="mx-2"
                                                            onClick={() => {
                                                                // if (
                                                                //     user?.momentoCount <
                                                                //     3
                                                                // ) {
                                                                dispatch(
                                                                    acceptMomentoReuest(
                                                                        item.id,
                                                                        "accepted",
                                                                        () => {
                                                                            history.push(
                                                                                `/main/create-momentos/${item.id}`
                                                                            );
                                                                        }
                                                                    )
                                                                );
                                                                // } else {

                                                                //     // toast.error(
                                                                //     //     "You have Reached your limit of mementos, either delete one or wait until one of your unique memenot is sold"
                                                                //     // );
                                                                // }
                                                            }}
                                                        >
                                                            Create Memento
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr color="blue">
                                        <td>N/A</td>
                                        <td className="text-capitalize">N/A</td>
                                        <td>N/A</td>
                                        <td className="text-capitalize">N/A</td>
                                        <td>N/A</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    )}
                </Container>
            </Container>
        </>
    );
};

export default MomentoRequests;
